import { Component, type ErrorInfo, type ReactNode } from 'react'

// Hotfix 053.
//
// WHY: this console had NO error boundary, so a single render exception
// anywhere blanked the entire app with no message — indistinguishable, from the
// operator's side, from the service being down. That is a bad failure mode on a
// surface whose whole job is telling an operator what state the platform is in.
//
// It is NOT the cause of the 2026-09-10 outage — that was a missing SPA
// fallback (see `public/staticwebapp.config.json`) — and this is deliberately
// not presented as the fix for it. It is here so the NEXT render exception
// produces something an operator can report instead of a white screen.
//
// A class component, because `getDerivedStateFromError` has no hook equivalent.
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Console only. There is no client telemetry in this app, and adding one
    // here would be a larger decision than a hotfix should take.
    console.error('Operator Console render error:', error, info.componentStack)
  }

  render() {
    if (!this.state.error) {
      return this.props.children
    }
    return (
      <div className="signin">
        <div className="signin-card">
          <h1>Something broke in the console</h1>
          <p>
            The page failed to render. This is a fault in the console itself, not necessarily in the
            ATC services — check the activity feed or retry the action from another page.
          </p>
          <p className="muted">
            Reloading may clear it. If it recurs, the message below is the useful part of a bug
            report.
          </p>
          <pre className="rx-error-detail">{this.state.error.message}</pre>
          <button className="btn-primary" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    )
  }
}
